<template>
  <v-col v-if="datas.length > 0" cols="12" class="test_blue">
    <v-radio-group
      v-model="selected"
      multiple
      :max="max"
      class="input-group-radio-stretch"
    >
      <template v-slot:label>
        <v-row no-gutters class="test_blue" align-content="center">
          <span class="modal-title-details" v-text="title" />
          <div class="pl-3">
            <v-icon
              v-if="error"
              color="red"
              small
              v-text="'mdi-alert-circle'"
            />
          </div>

          <span
            class="pl-1 modal-title-rules"
            :class="{ errorRule: error }"
            v-text="
              $t('general.minimum') +
              ': ' +
              min +
              ' - ' +
              $t('general.maximum') +
              ': ' +
              max
            "
          />
        </v-row>
      </template>
      <v-row
        v-for="item in datas"
        :key="item.pivotId"
        no-gutters
        justify="space-between"
        align="start"
        style="margin-bottom: 5px"
      >
        <v-col cols="8" class="test_red test-check">
          <v-checkbox
            v-model="selected"
            :value="item.pivotId"
            :disabled="checkDisable(item.pivotId)"
            class="input-details-disable"
          >
            <template v-slot:label>
              <span class="modal-name-details" style="margin-top: 6px">
                <strong v-if="show(item.pivotId)"
                  >{{ getQty(item.pivotId) }}x </strong
                >{{ item.name }}
              </span>
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="4" class="test_blue">
          <v-container fluid>
            <v-row justify="end" align="start">
              <span
                :class="show(item.pivotId) ? 'active' : 'inactive'"
                class="modal-price-details"
                style="margin-top: 6px"
                v-text="$appFormatters.formatMoney(item.price)"
              />
              <!--              <div v-if="show(item.pivotId)" class="pl-5">-->
              <!--                <v-btn-->
              <!--                  icon-->
              <!--                  :disabled="getQty(item.pivotId) < 2"-->
              <!--                  @click.prevent="decrement(item.pivotId)"-->
              <!--                >-->
              <!--                  <v-icon v-text="'mdi-minus-circle-outline'" />-->
              <!--                </v-btn>-->
              <!--                <v-btn icon @click.prevent="increment(item.pivotId)">-->
              <!--                  <v-icon v-text="'mdi-plus-circle-outline'" />-->
              <!--                </v-btn>-->
              <!--              </div>-->
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-radio-group>
  </v-col>
</template>

<script>
export default {
  name: "AddonMultiplecomponent",
  props: {
    title: {
      type: String,
      required: true,
    },
    datas: {
      type: Array,
      default: null,
    },
    max: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    selected: [],
    detailsSelected: [],
    error: false,
  }),
  watch: {
    selected: function (value) {
      const self = this;
      if (value.length > 0) {
        for (let index = 0; index < self.selected.length; index++) {
          let exist = _.find(self.detailsSelected, {
            productSubAddonPivotId: self.selected[index],
          });
          if (!exist) {
            self.addToArray(index);
          }
          self.filterArray();
        }
      } else {
        self.detailsSelected = [];
      }
      if (this.selected.length < this.min) {
        this.error = true;
      } else {
        this.error = false;
      }
    },

    detailsSelected: function () {
      this.$emit("input", this.detailsSelected);
    },
    error: function (o, n) {
      if (n == false) {
        this.$store.dispatch(
          "discovery/set_AddosError",
          this.$store.getters.addonsProductErrors + 1
        );
      }
      if (n == true) {
        this.$store.dispatch(
          "discovery/set_AddosError",
          this.$store.getters.addonsProductErrors - 1
        );
      }
    },
  },
  mounted() {
    if (this.selected.length < this.min) {
      this.error = true;
      this.$emit("input", false);
    } else {
      this.$emit("input", this.selected);
      this.error = false;
    }
  },
  methods: {
    checkDisable: function (id) {
      const self = this;
      if (self.selected.includes(id)) {
        return false;
      } else {
        return self.selected.length >= self.max;
      }
    },
    show: function (id) {
      const self = this;
      return self.selected.includes(id);
    },
    addToArray: function (index) {
      const self = this;
      let item = _.find(self.datas, {
        pivotId: self.selected[index],
      });
      self.detailsSelected.push({
        productSubAddonPivotId: self.selected[index],
        price: item.price,
        subAddonQty: 1,
        subtotal: item.price,
      });
    },
    filterArray: function () {
      const self = this;
      self.detailsSelected = _.filter(self.detailsSelected, function (item) {
        return _.includes(self.selected, item.productSubAddonPivotId);
      });
    },
    getQty: function (id) {
      const self = this;
      let item = _.find(self.detailsSelected, {
        productSubAddonPivotId: id,
      });
      return item.subAddonQty;
    },
    increment: function (id) {
      const self = this;
      let index = self.detailsSelected.findIndex(
        (item) => item.productSubAddonPivotId === id
      );
      self.detailsSelected[index].subAddonQty =
        parseInt(self.detailsSelected[index].subAddonQty, 10) + 1;
      self.detailsSelected[index].subtotal =
        self.detailsSelected[index].subAddonQty *
        self.detailsSelected[index].price;
    },
    decrement: function (id) {
      const self = this;
      let index = self.detailsSelected.findIndex(
        (item) => item.productSubAddonPivotId === id
      );
      self.detailsSelected[index].subAddonQty =
        parseInt(self.detailsSelected[index].subAddonQty, 10) + -1;
      self.detailsSelected[index].subtotal =
        self.detailsSelected[index].subAddonQty *
        self.detailsSelected[index].price;
    },
  },
};
</script>
<style lang="scss" scoped>
.errorRule {
  color: red !important;
}
.label-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start; /* Aligns both items to the start */
  gap: 10px;
}
</style>
